import ChatBg from "./chat-bg.svg";

const svg = { ChatBg };

export default svg;
